export default __webpack_public_path__ + "static/media/close.7ba9ee0a.svg";